import React, { useEffect, useRef, useState } from "react";
import { ChevronDownIcon } from "lucide-react";
import { navGroups } from "../../data/site";
import { SiteLink } from "../SiteLink";
export function DesktopNav() {
  const [openId, setOpenId] = useState<string | null>(null);
  const navRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (!openId) return;
    const onPointerDown = (e: MouseEvent) => {
      if (navRef.current && !navRef.current.contains(e.target as Node)) setOpenId(null);
    };
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        const current = openId;
        setOpenId(null);
        document.getElementById(`nav-btn-${current}`)?.focus();
      }
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [openId]);
  const handleBlur = (e: React.FocusEvent<HTMLLIElement>) => {
    if (!e.currentTarget.contains(e.relatedTarget as Node | null)) setOpenId(null);
  };
  return <nav ref={navRef} aria-label="Main" className="hidden nav:block" data-id="element-100" data-mp="126myax11xgh6">
      <ul className="flex items-center justify-between gap-2" data-id="element-101" data-mp="128zasuo1iymu">
        {navGroups.map((group, index) => {
        const isOpen = openId === group.id;
        return <li key={group.id} className="relative" onBlur={handleBlur} data-id="element-102" data-mp="9ir17r7klmjv" data-mpi={index}>
              <button id={`nav-btn-${group.id}`} type="button" aria-expanded={isOpen} aria-controls={`nav-panel-${group.id}`} onClick={() => setOpenId(isOpen ? null : group.id)} className={`inline-flex min-h-[48px] items-center gap-2 px-4 text-label font-bold ${isOpen ? "bg-white text-ink" : "text-white hover:bg-white/10"}`} data-id="element-103" data-mp="4k62xxbvpcy2">
                {group.label}
                <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 ${isOpen ? "rotate-180 text-ink" : "text-white"}`} data-id="element-104" data-mp="ml1rjkfmeyhe" />
              </button>
              {isOpen && <div id={`nav-panel-${group.id}`} className={`absolute top-full z-30 max-h-[calc(100dvh-var(--site-header-height,154px)-12px)] overflow-y-auto w-[360px] border border-line bg-white p-2 shadow-[0_12px_32px_rgba(0,0,0,0.18)] ${index >= navGroups.length - 2 ? "right-0" : "left-0"}`} data-id="element-105" data-mp="whwq23bw8yvo">
                  <ul data-id="element-106" data-mp="cuypkuqiua6x">
                    {group.links.map(link => <li key={link.path} data-id="element-107" data-mp="hmqhp9pbsnz6">
                        <SiteLink path={link.path} onClick={() => setOpenId(null)} className="flex min-h-[48px] items-center rounded-md px-4 py-2.5 text-label font-semibold text-ink hover:bg-ivory hover:text-crimson" data-id="element-108" data-mp="hnrubilzpij0">
                          {link.label}
                        </SiteLink>
                      </li>)}
                  </ul>
                </div>}
            </li>;
      })}
      </ul>
    </nav>;
}